import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
// import { useQueryParam, StringParam } from 'use-query-params';
import useTranslation from './useTranslation';
import { NOTIFICATION_KEY } from '../utils/config';
function errorWithCode(t, errorCode, notificationKey) {
    return t('notification.loginError', 'Sorry, please try again. {{notificationKey}} (error code {{errorCode}})', { notificationKey, errorCode });
}
export const getNotification = (notificationKey, t) => {
    let message;
    let type;
    switch (notificationKey) {
        // case 'MissingAuthTokenError':
        //   message = t(
        //     'notification.missingAuthTokenError',
        //     'Sorry, there was a problem with your login.'
        //   );
        //   type = 'error';
        //   break;
        case 'TokenExpiredError':
            message = errorWithCode(t, 'S1', notificationKey);
            type = 'error';
            break;
        // case 'NotBeforeError':
        //   message = t(
        //     'notification.loginError',
        //     'Sorry, please try again. {{notificationKey}} (error code {{errorCode}})',
        //     { notificationKey, errorCode: 'S2' }
        //   );
        //   type = 'error';
        //   break;
        // ? needed now?
        // MissingHash
        // InvalidHash
        // case 'JsonWebTokenError':
        //   message = t(
        //     'notification.loginError',
        //     'Sorry, please try again. {{notificationKey}} (error code {{errorCode}})',
        //     { notificationKey, errorCode: 'S3' }
        //   );
        //   type = 'error';
        //   break;
        // case 'DataIncompleteError':
        //   message = t(
        //     'notification.loginError',
        //     'Sorry, please try again. {{notificationKey}} (error code {{errorCode}})',
        //     { notificationKey, errorCode: 'S5' }
        //   );
        //   type = 'error';
        //   break;
        case 'LoggedIn':
            message = t('notification.loggedIn', 'Logged in.');
            type = 'success';
            break;
        case 'LoggedOut':
            message = t('notification.loggedOut', 'Logged out.');
            type = 'success';
            break;
        // case 'GetUserTokenError':
        // case 'SignTokenError':
        // case 'VerifyTokenError':
        default:
            message = t('notification.generalError', 'Sorry something went wrong, please try again. \n({{notificationKey}})', { notificationKey });
            type = 'error';
    }
    return { message, type };
};
export default function useNotifications() {
    const { t } = useTranslation();
    const notificationParamKey = Cookies.get(NOTIFICATION_KEY);
    const [notificationKey, setNotificationKey] = useState(notificationParamKey);
    // Now remove it as we don't want it on refresh.
    useEffect(() => {
        Cookies.remove(NOTIFICATION_KEY);
    }, []);
    const clearNotification = () => {
        setNotificationKey(undefined);
    };
    let notification;
    if (notificationKey) {
        notification = getNotification(notificationKey, t);
    }
    return {
        notification,
        clearNotification,
    };
}
//# sourceMappingURL=useNotifications.js.map